import React from 'react';
import About from './components/pages/About';
import Banner from './components/Utils/Banner';
import Header from './components/Utils/Header';
import Tests from './components/pages/Tests';
import Home from './components/pages/Home';
import Weekly from './components/pages/Weekly';
import Results from './components/pages/Results';
import Test from './components/pages/Test';
import TestCreator from './components/pages/TestCreator';
import Login from './components/pages/Login';     
import Signup from './components/pages/Signup';    
import Sidebar from './components/Utils/Sidebar';
import ForgotPassword from "./components/pages/ForgotPassword";
import { createBrowserRouter, RouterProvider, Navigate } from 'react-router-dom';
import { useAuth } from './AuthContext';
import PrivateRoute from './PrivateRoute';

function AppRoutes() {
  const { user } = useAuth();

  const router = createBrowserRouter([
    {
      path: '/',
      element: <Navigate to="/login" replace />, // Redirect root to /login
    },
   {
  path: '/login',
  element:  <Login />,
},
{
  path: '/signup',
  element: <Signup />,
},
{
  path: '/forgot-password',
  element: user ? <Navigate to="/home" replace /> : <ForgotPassword />,

},

    {
      path: '/home',
      element: (
        <PrivateRoute>
          <>
            <Header />
            <Home />
            <Banner />
          </>
        </PrivateRoute>
      ),
    },
    {
      path: '/about',
      element: (
        <PrivateRoute>
          <>
            <Header />
            <About />
          </>
        </PrivateRoute>
      ),
    },
    {
      path: '/tests',
      element: (
        <PrivateRoute>
          <>
            <Header />
            <Tests />
          </>
        </PrivateRoute>
      ),
    },
    {
      path: '/results',
      element: (
        <PrivateRoute>
          <>
            <Header />
            <Results />
          </>
        </PrivateRoute>
      ),
    },
    {
      path: '/create',
      element: (
        <PrivateRoute>
          <>
            <Header />
            <Sidebar />
          </>
        </PrivateRoute>
      ),
    },
    {
      path: '/weekly',
      element: (
        <PrivateRoute>
          <>
            <Header />
            <Weekly />
          </>
        </PrivateRoute>
      ),
    },
    {
       path: '/test/:testName', 
      element: (
        <PrivateRoute>
          <Test />
        </PrivateRoute>
      ),
    },
  ]);

  return <RouterProvider router={router} />;
}

export default AppRoutes;
